import PropTypes from 'prop-types';
import { combineReducers } from 'redux';
import { globalizeSelectors } from '../Utils';
import { createArrayDataReducer, arrayDataType } from '../factories/ApiCall';
import type {
  BarcodeSearchAction,
  BarcodeSearchPayload,
  BarcodeSearchResult,
  BarcodeSearchState,
} from '../types/BarcodeSearch';

/*
 * action types
 */

const types = {
  SEARCH_BARCODES: 'BARCODEACTIONS/SEARCH_BARCODES',
} as const;

const mountPath = 'barcodesearch'; // mount point in global state, must match root reducer

/*
 * action creators
 */

const actions = {
  searchBarcodes: (
    search: string
  ): BarcodeSearchAction<BarcodeSearchPayload> => ({
    type: types.SEARCH_BARCODES,
    payload: { search },
  }),
};

/*
 * state shape
 */
const propType = PropTypes.shape({
  barcodes: arrayDataType,
});

/*
 * reducer
 */
const reducer = combineReducers({
  barcodes: createArrayDataReducer<BarcodeSearchResult, BarcodeSearchPayload>(
    types.SEARCH_BARCODES
  ),
}) as (
  state: BarcodeSearchState | undefined,
  action: BarcodeSearchAction
) => BarcodeSearchState;

/*
 * selectors
 */
const localSelectors = {
  barcodes: (state: BarcodeSearchState): BarcodeSearchState['barcodes'] =>
    state.barcodes,
};

const selectors = globalizeSelectors(localSelectors, mountPath);

export {
  types as actionTypes,
  actions as default,
  propType,
  selectors,
  reducer,
};
